export default __webpack_public_path__ + "static/media/Cierra_Jayde_AHV_In_Moms_We_Trust.9779c4f8.jpg";